import { Component } from '@angular/core';
import { IonicPage, NavController, App, Platform, LoadingController, AlertController } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { Http } from '@angular/http';
import { OrdersProvider } from '../../providers/orders/orders';
//import { ImagesPage } from '../../pages/images/images';
import { GlobalProvider } from "../../providers/global/global";


// import { Globalization } from '@ionic-native/globalization';
// import { defaultLanguage, availableLanguages, sysOptions }  from 'i18n';


@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  loading: any;

  fromDateReport: string;
  toDateReport: string;

  constructor(public orderService: OrdersProvider, public http: Http, public platform: Platform, public navCtrl: NavController, 
    public rest: RestProvider, public app: App, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public global: GlobalProvider) {
  }

  ionViewDidLoad() {
    console.log('Hello from Home Page');
  }

  getRejectionReport(){
    console.log("Donwload Rejection Report");

    let from = this.fromDateReport;
    let to = this.toDateReport;

     this.orderService.downloadRejectionReportFile(from, to).then((result: any) => {
            //if(this.loading){ this.loading.dismiss(); this.loading = undefined };
            let fileURL = result.data;
  
                  // Get File for CORE
                  this.orderService.getFile(fileURL)
                  .subscribe(fileData => 
                    {
                    let b:any = new Blob([fileData], { type: 'text/comma-separated-values' });
                    var url= window.URL.createObjectURL(b);
                      window.open(url); 
                    }
                  );
                  //return false;
                
            

 

            //Navigate to Publisher
            console.log("Report downloaded successfully", result);
        }, (err) => {
            if(this.loading){ this.loading.dismiss(); this.loading = undefined };
            this.fireAlert(err.json().message);
    });
  }

  openPartnersPage(){
    this.navCtrl.setRoot('PartnersPage');
  }

  getImageUploadReport(){
    console.log("Donwload Upload Report");

    let from = this.fromDateReport;
    let to = this.toDateReport;

     this.orderService.downloadReportFile(from, to).then((result: any) => {
            //if(this.loading){ this.loading.dismiss(); this.loading = undefined };
            let fileURL = result.data;
  
                  // Get File for CORE
                  this.orderService.getFile(fileURL)
                  .subscribe(fileData => 
                    {
                    let b:any = new Blob([fileData], { type: 'text/comma-separated-values' });
                    var url= window.URL.createObjectURL(b);
                      window.open(url); 
                    }
                  );
                  //return false;
                
            

 

            //Navigate to Publisher
            console.log("Report downloaded successfully", result);
        }, (err) => {
            if(this.loading){ this.loading.dismiss(); this.loading = undefined };
            this.fireAlert(err.json().message);
    });
  }


   fireAlert(message: string) {
    let alert = this.alertCtrl.create({
                                    message: message,
                                    //duration: 2000,
                                    //position: 'bottom'
                                  });
                alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts